import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-payment-card-endorder',
  templateUrl: './payment-card-endorder.component.html',
  styleUrls: ['./payment-card-endorder.component.css']
})
export class PaymentCardEndorderComponent implements OnInit {

  @Input()
  currCard$: any;
 


  @Input()
  clientCardLoader:boolean|any;

  constructor() { }

  ngOnInit() {
 
  }

  ngOnChanges(changes: SimpleChanges): void {
  
   
    if (changes['currCard$'] && changes['currCard$'].currentValue) {
      this.currCard$ = changes['currCard$'].currentValue;
     
    }
 
  }


}
